import { createSelector } from 'reselect';
import { size } from 'lodash';

export const getBrowse = ({ browse = {} }) => browse;

export const getSelectedSorts = createSelector(
  getBrowse,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSorts' does not exist on type '{... Remove this comment to see the full error message
  ({ selectedSorts = {} }) => selectedSorts,
);
export const getSelectedSortValue = createSelector(
  getSelectedSorts,
  ({ value }) => value,
);

// @ts-expect-error ts-migrate(2339) FIXME: Property 'paging' does not exist on type '{}'.
export const getPaging = createSelector(getBrowse, ({ paging = {} }) => paging);
export const getAlgoliaQuery = createSelector(
  getPaging,
  ({ queryID = '' }) => queryID,
);
export const getAlgoliaIndex = createSelector(
  getPaging,
  ({ index = '' }) => index,
);

export const getSelectedFilters = createSelector(
  getBrowse,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedFilters' does not exist on type ... Remove this comment to see the full error message
  ({ selectedFilters = {} }) => selectedFilters,
);
export const getSelectedFiltersLength = createSelector(
  getSelectedFilters,
  (selectedFilters = {}) =>
    Object.values(selectedFilters).reduce(
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      (acc, filter) => acc + size(filter),
      0,
    ),
);

export const getCurrentPageNumber = createSelector(
  getPaging,
  ({ page = 1 }) => page,
);

export const getSearchTerm = createSelector(
  getBrowse,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{}' is not assignable to type 'R1'.
  ({ searchTerm = '' } = {}) => searchTerm,
);

export const getSelectedFiltersNames = createSelector(
  getSelectedFilters,
  (selectedFilters) => {
    const keys = Object.keys(selectedFilters);
    const child = keys.map((key) => selectedFilters[key]);
    const tagSets = child.map((bottomFilter) => {
      const key = Object.keys(bottomFilter);
      return key.map((i) => bottomFilter?.[i]?.name);
    });

    return tagSets.reduce((acc, cur) => [...acc, ...cur], []);
  },
);
